import React from "react";
import { MOOD_COLORS } from "constants/moodColors";
import styles from "./Trends.module.css";
import { BarColumn } from "./BarColumn";

const MOOD_LEGEND = [
  { name: "Apathy", color: MOOD_COLORS.Apathy },
  { name: "Flow", color: MOOD_COLORS.Flow },
  { name: "Anxiety", color: MOOD_COLORS.Anxiety },
  { name: "Calm", color: MOOD_COLORS.Confident },
];

const ROW_STACK_GAP_PX = 4;

export type BarChartProps = {
  barChartData: any;
  weekdayLabels: any;
  maxBarHeight: any;
};

export default function BarChart({
  barChartData,
  weekdayLabels,
  maxBarHeight,
}: BarChartProps) {
  const rows = Array.isArray(barChartData[0]) ? barChartData : [barChartData];
  const rowCount = rows.length;

  return (
    <>
      {rowCount === 0 ? (
        <div className={styles["bar-chart-container"]}>
          <p
            className={styles["day-label-item"]}
            style={{ textAlign: "center" }}
          >
            No chart data for this period
          </p>
        </div>
      ) : (
        <div className={styles["bar-chart-container"]}>
          <div className={styles["day-labels-container"]}>
            {weekdayLabels.map((day: any, index: any) => (
              <div key={index} className={styles["day-label-item"]}>
                {day}
              </div>
            ))}
          </div>
          <div
            className={styles["bars-container"]}
            style={{
              height: `${
                maxBarHeight * rowCount + ROW_STACK_GAP_PX * (rowCount - 1)
              }px`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              gap: `${ROW_STACK_GAP_PX}px`,
            }}
          >
            {rows.map((row: any, rowIndex: number) => (
              <div
                key={rowIndex}
                className={styles["bars-row"]}
                style={{
                  height: `${maxBarHeight}px`,
                  flex: "none",
                  marginBottom: 0,
                }}
              >
                {row.map((barData: any, index: number) => (
                  <BarColumn
                    key={`${rowIndex}-${index}`}
                    barData={barData}
                    index={index}
                    rowIndex={rowIndex}
                  />
                ))}
              </div>
            ))}
          </div>
          <div className={styles["color-legend-container"]}>
            {MOOD_LEGEND.map((mood, index) => (
              <div key={index} className={styles["color-legend-item"]}>
                <div
                  className={styles["color-legend-square"]}
                  style={{ backgroundColor: mood.color }}
                />
                <div className={styles["color-legend-text-container"]}>
                  <span className={styles["color-legend-label"]}>
                    {mood.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
